{
  "Personel Listesi": "Staff List",
  "İzin Rapor": "Leave Report",
  "personel": {
    "Ad Soyad": "Name Surname",
    "Adres": "Address",
    "Aç": "Open",
    "Açıklama": "Description",
    "Banka": "Bank",
    "Banka Güncelle": "Update Bank",
    "Başlangıç Tarih": "Start Date",
    "Belge Tür": "Document Type",
    "Bilgi Notu": "Information Note",
    "Bitiş Tarih": "End Date",
    "Bölüm": "Department",
    "Cep": "Mobile",
    "Cinsiyet": "Gender",
    "Dosya": "File",
    "Dosya yok": "No file",
    "Dosyalar": "Files",
    "Doğum Tarih": "Birth Date",
    "Doğum Tarihi": "Date of Birth",
    "Durum": "Status",
    "Düşünceler": "Thoughts",
    "E-mail": "E-mail",
    "Evlilik Tarihi": "Marriage Date",
    "Eğitim": "Education",
    "Fakülte": "Faculty",
    "Form Yazdır": "Print Form",
    "Gün Dakika": "Day Minute",
    "IBAN": "IBAN",
    "IndirGoruntule": "Download/View",
    "Is_Bas_Tar": "Employment Start Date",
    "Izin Rapor": "Leave Report",
    "Kalan Ücretli İzin Günü": "Remaining Paid Leave Days",
    "Kalan İzin": "Remaining Leave",
    "Kan Grubu": "Blood Type",
    "Kart No": "Card No",
    "Kayıtlı aşama bulunamadı": "No recorded stage found.",
    "Kimlik No": "Identity No",
    "Koordinat X (Enlem)": "Coordinate X (Latitude)",
    "Koordinat Y (Boylam)": "Coordinate Y (Longitude)",
    "Koordinat Çek": "Fetch Coordinates",
    "Kullanıcı": "User",
    "Kurum/Okul": "Institution/School",
    "Madde": "Item",
    "Medeni Durum": "Marital Status",
    "Medeni Hal": "Marital Status",
    "Not": "Note",
    "Personel": "Personnel",
    "Personel Dosyaları": "Personnel Files",
    "Personel Listesi": "Staff List",
    "Personel Profil": "Personnel Profile",
    "Resim": "Image",
    "Sicil No": "Registration No",
    "Tarih": "Date",
    "Tarihi": "Date",
    "Telefon": "Phone",
    "Teslim Tarihi": "Delivery Date",
    "Tüm Personel Dosyaları": "All Personnel Files",
    "Yakınlık": "Proximity",
    "Yemek Durum": "Meal (Active/Passive)",
    "Yemek Kart Tipi": "Meal Card Type",
    "Yeni Banka": "New Bank",
    "Ara": "Search",
    "Temizle": "Clear",
    "Kapat": "Close",
    "Yenile": "Refresh",
    "Zimmet": "Embezzlement",
    "diger": "Other",
    "kimlikno": "Identity No",
    "mazaret": "Excuse",
    "rapor": "Report",
    "toplam": "Total",
    "ucretli": "Paid",
    "ucretsiz": "Unpaid",
    "Çocuk Sayısı": "Number of Children",
    "Öğrenim": "Education",
    "Ürün": "Product",
    "İade Tarih": "Return Date",
    "İade Tarihi": "Return Date",
    "İzin": "Leave",
    "İzin Hakediş Tar": "Leave Entitlement Date",
    "İzin Hakediş Tarihi": "Leave Entitlement Date",
    "İzin Rapor": "Leave Report",
    "İzin Yenile": "Renew Leave",
    "İzinli Gün": "Leave Day",
    "İş Başlangıç": "Job Start",
    "İş Başlangıç Tarihi": "Employment Start Date",
    "İş Bitiş": "End Date",
    "İş Bitiş Tarihi": "End Date of Employment",
    "İş Giriş Aşamaları": "Job Entry Stages",
    "İş Çıkış Aşamaları": "Job Exit Stages",
    "Şube": "Branch"
  }
}
